module.exports = __webpack_public_path__ + "media/images/cbjj/academy_registration_informations/team_size-b93ca0f2419ef1a044da88901d6f66f6.svg";